import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useMeterAssignments} from '../hooks/useMeterAssignments.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useMeterAssignments();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
